<template>
  <v-container
    id="view-dashboard"
    fluid
    v-if="loaded"
  >
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <v-card
              color="#5d3791"
              dark
            >
              <v-card-title class="text-h5">
                {{ dashboard.endpoint_count }} Data Endpoint<span v-if="dashboard.endpoint_count !== 1">s</span>
              </v-card-title>

              <v-card-subtitle>{{ dashboard.endpoint_count }} data endpoint(s) are available with meter data.</v-card-subtitle>
            </v-card>
          </v-col>

          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <v-card
              color="#5d3791"
              dark
            >
              <v-card-title class="text-h5">
                {{ dashboard.meter_count }} Meter<span v-if="dashboard.meter_count !== 1">s</span>
              </v-card-title>

              <v-card-subtitle>Your {{ dashboard.endpoint_count }} data endpoint(s) have {{ dashboard.meter_count }} meters attached.</v-card-subtitle>

            </v-card>
          </v-col>

          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <v-card
              color="#5d3791"
              dark
            >
              <v-card-title class="text-h5">
                {{ dashboard.read_count }} Read<span v-if="dashboard.read_count !== 1">s</span>
              </v-card-title>

              <v-card-subtitle>In the last 7 days we have received {{ dashboard.read_count }} reads.</v-card-subtitle>

            </v-card>
          </v-col>

          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <v-card
              :color="errorColor"
              dark
            >
              <v-card-title class="text-h5">
                {{ dashboard.meter_error_count }} Missing Read<span v-if="dashboard.meter_error_count !== 1">s</span>
              </v-card-title>

              <v-card-subtitle>In the last 24 hours {{ dashboard.meter_error_count }} meter<span v-if="dashboard.meter_error_count !== 1">s have</span><span v-else> has</span> received no reads.</v-card-subtitle>

            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-sheet
          color="white"
          elevation="1"
          class="pa-5"
        >
          <apexchart height="600" type="bar" :options="optionData" :series="seriesData"></apexchart>
        </v-sheet>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from "vue";
import VueApexCharts from 'vue-apexcharts';
import { get } from 'vuex-pathify';

Vue.use(VueApexCharts);


export default {
  name: "Dashboard",
  components: {
    apexchart: VueApexCharts,
  },
  computed: {
    dashboard: get('dashboard/dashboard')
  },
  data: () => ({
    loaded: false,
    errorColor: "#AAAAAA",
    seriesData: [{
      name: 'Reads',
      type: 'bar',
      data: []
    }, {
      name: 'Missing Data',
      type: 'bar',
      data: []
    }],
    optionData: {
      tooltip: {
        x: {
          format: "dd MMM yyyy",
          formatter: (value) => {
            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            const date = new Date(value);
            return date.getDate() + " " + monthNames[date.getMonth()];
          }
        }
      },
      chart: {
        height: 350,
        type: 'bar',
        zoom: {
          enabled: false
        }
      },
      colors: ['#546E7A', '#E91E63'],
      stroke: {
        width: [0, 4]
      },
      title: {
        text: 'Last 7 Day Reads/Missing Data'
      },
      dataLabels: {
        enabled: true,
        enabledOnSeries: [1]
      },
      labels: [],
      xaxis: {
        type: 'datetime'
      },
      yaxis: [
        {
          title: {
            text: 'Reads',
          },
          labels: {
            formatter: function(val) {
              return val.toFixed(0);
            }
          }
        },
        {
          opposite: true,
          title: {
            text: 'Missing Data'
          },
          labels: {
            formatter: function(val) {
              return val.toFixed(0);
            }
          }
        }
      ]
    }
  }),
  created() {
    this.$store.dispatch("loader/loaderCancel");
    this.fetchData();
  },
  methods: {
    getMonthFromNumberNew(date) {
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      return monthNames[date];
    },
    async fetchData() {
      await this.$store.dispatch("loader/loaderInitiate", { title: "Loading dashboard" });

      await this.$store.dispatch("dashboard/getDashboard");

      await this.$store.dispatch("loader/loaderCancel");

      this.optionData.labels = this.dashboard.past_7.dates;
      this.seriesData[0].data = this.dashboard.past_7.reads;
      this.seriesData[1].data = this.dashboard.past_7.errors;

      this.setErrorColor();

      this.loaded = true;
    },
    setErrorColor() {
      if (this.dashboard.meter_error_count > 0) {
        this.errorColor = "#FF4136";
      }
    }
  }
}
</script>

<style scoped>

</style>
